import { get } from '../common/util';

/* Every property translated to integer here follows ascending order.
 * Eg, Dev > Admin > User, therefore { Dev: 2 Admin: 1 User: 0 }
 *
 * This is done for quick comparisons without IFs or switch
 */
const debug = false;
export const log = debug ? console.log.bind(window.console) : () => {};

const depts = {
  base: 'base',
  all: '*'
};
const roles = {
  dev: 4,
  admin: 3,
  backoffice: 2,
  user: 1
};

const scopes = {
  external: 1,
  internal: 2
};

const permissions = {
  menu: {
    example: {
      requirements: {
        department: depts.all,
        scope: scopes.external,
        role: roles.user
      }
    },
    settings: {
      requirements: {
        department: depts.all,
        scope: scopes.internal,
        role: roles.admin
      },
      users: {
        requirements: {
          department: depts.all,
          scope: scopes.internal,
          role: roles.admin
        },
        groups: {
          requirements: {
            department: depts.base,
            scope: scopes.internal,
            role: roles.admin
          }
        }
      },
      groups: {
        requirements: {
          department: depts.base,
          scope: scopes.internal,
          role: roles.admin
        }
      }
    }
  },
  pages: {
    example: {
      requirements: {
        department: depts.cm,
        scope: scopes.internal,
        role: roles.user
      }
    }
  },
  crm: {
    requirements: {
      department: depts.cm,
      scope: scopes.external,
      role: roles.user
    },
    tags: {
      requirements: {
        department: depts.cm,
        scope: scopes.internal,
        role: roles.user
      }
    },
    posts: {
      internal: {
        requirements: {
          department: depts.cm,
          scope: scopes.internal,
          role: roles.user
        }
      },
      selectVisibility: {
        requirements: {
          department: depts.cm,
          scope: scopes.internal,
          role: roles.user
        }
      }
    }
  }
};

export default class Permissions {
  static check(scope, userData) {
    if (!userData) {
      console.warn('Permissions: userData not valid: ', userData);
      return false;
    }

    const translated = {
      role: roles[userData.role],
      scope: scopes[userData.permissions.scope],
      department: userData.permissions.department.toLowerCase()
    };

    if (!translated.role || !translated.scope || !translated.department) {
      log(
        'Permissions: User data is missing role or permissions: ',
        translated
      );
      throw new Error(
        'Permissions: User data is missing role or permissions: ',
        translated
      );
    }

    const coordinates = scope.replace(/:/g, '.');

    const target = get(coordinates, permissions);

    if (!target) {
      log('Permissions: Missing user permissions: ', scope);
      throw new Error('Permissions: Missing user permissions: ' + scope);
    }

    const requirements = target.requirements;
    log('permissions - translated :', translated);
    log('permissions - target :', target);

    const isDev = false; //translated.role >= roles.dev;

    if (isDev) {
      log('Permissions: is dev,returning true');
      return true;
    } else {
      log(
        'Permissions: not admin, returning: ',
        translated.role >= requirements.role,
        translated.scope >= requirements.scope,
        requirements.department === depts.all ||
          translated.department === depts.all ||
          translated.department === requirements.department
      );
      return (
        translated.role >= requirements.role &&
        translated.scope >= requirements.scope &&
        (requirements.department === depts.all ||
          translated.department === depts.all ||
          translated.department === requirements.department)
      );
    }
  }
}
